import { render, staticRenderFns } from "./AppTableRouter.vue?vue&type=template&id=77aaa82d&scoped=true&"
import script from "./AppTableRouter.vue?vue&type=script&lang=ts&"
export * from "./AppTableRouter.vue?vue&type=script&lang=ts&"
import style0 from "./AppTableRouter.vue?vue&type=style&index=0&id=77aaa82d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aaa82d",
  null
  
)

export default component.exports